export default __webpack_public_path__ + "static/media/billing-empty-state-icon.d0a62b64.svg";